import React from 'react';
import PivotSVG from 'assets/images/wv-pivot-selector.svg?react';
import { cn } from '@utils';
import { ToothMovementPoints } from '@data/models';

type ToothOriginPointSelectProps = {
  selectedToothOriginPoint: ToothMovementPoints;
  setSelectedToothOriginPoint: any;
  defaultOriginPoint: ToothMovementPoints;
};

export function ToothOriginPointSelect({
  selectedToothOriginPoint,
  setSelectedToothOriginPoint,
  defaultOriginPoint,
}: ToothOriginPointSelectProps) {
  return (
    <div className="w-11 flex items-center justify-center relative -mb-3">
      <div
        onClick={() => setSelectedToothOriginPoint(ToothMovementPoints.RootTip)}
        className={cn(
          '-translate-y-[50%] -translate-x-[50%] absolute left-5 top-[12px] p-3 w-1.5 h-1.5 hover:cursor-pointer transition-all',
          selectedToothOriginPoint === ToothMovementPoints.RootTip &&
            '[&>div]:w-3 [&>div]:h-3 [&>div]:bg-[#70CADE] [&>div]:border-[#344952]',
          !(selectedToothOriginPoint === 'RootTip') &&
            '[&>div]:betterhover:hover:border-2 [&>div]:betterhover:hover:bg-[#70CADE] [&>div]:betterhover:hover:border-[#344952] [&>div]:betterhover:hover:w-2 [&>div]:betterhover:hover:h-2'
        )}
      >
        <div
          className={cn(
            'absolute top-1/2 left-1/2 w-1.5 h-1.5 -translate-y-[50%] -translate-x-[50%] bg-[#455A64] border border-[#6899B0] rounded-full',
            defaultOriginPoint === ToothMovementPoints.RootTip &&
              'bg-originPointBg border-originPointBorder'
          )}
        />
      </div>
      <div
        onClick={() =>
          setSelectedToothOriginPoint(ToothMovementPoints.CenterOfResistance)
        }
        className={cn(
          '-translate-y-[50%] -translate-x-[50%] absolute left-5 top-[34px] p-3 w-1.5 h-1.5 hover:cursor-pointer transition-all',
          selectedToothOriginPoint === ToothMovementPoints.CenterOfResistance &&
            '[&>div]:w-3 [&>div]:h-3 [&>div]:bg-[#70CADE] [&>div]:border-[#344952]',
          !(
            selectedToothOriginPoint === ToothMovementPoints.CenterOfResistance
          ) &&
            '[&>div]:betterhover:hover:border-2 [&>div]:betterhover:hover:bg-[#70CADE] [&>div]:betterhover:hover:border-[#344952] [&>div]:betterhover:hover:w-2 [&>div]:betterhover:hover:h-2'
        )}
      >
        <div
          className={cn(
            'absolute top-1/2 left-1/2 w-1.5 h-1.5 -translate-y-[50%] -translate-x-[50%] bg-[#455A64] border border-[#6899B0] rounded-full',
            defaultOriginPoint === ToothMovementPoints.CenterOfResistance &&
              'bg-originPointBg border-originPointBorder'
          )}
        />
      </div>
      <div
        onClick={() =>
          setSelectedToothOriginPoint(ToothMovementPoints.CrownCenter)
        }
        className={cn(
          '-translate-y-[50%] -translate-x-[50%] absolute left-5 top-[70px] p-3 w-1.5 h-1.5 hover:cursor-pointer transition-all',
          selectedToothOriginPoint === ToothMovementPoints.CrownCenter &&
            '[&>div]:w-3 [&>div]:h-3 [&>div]:bg-[#70CADE] [&>div]:border-[#344952]',
          !(selectedToothOriginPoint === ToothMovementPoints.CrownCenter) &&
            '[&>div]:betterhover:hover:border-2 [&>div]:betterhover:hover:bg-[#70CADE] [&>div]:betterhover:hover:border-[#344952] [&>div]:betterhover:hover:w-2 [&>div]:betterhover:hover:h-2'
        )}
      >
        <div
          className={cn(
            'absolute top-1/2 left-1/2 w-1.5 h-1.5 -translate-y-[50%] -translate-x-[50%] bg-[#455A64] border border-[#6899B0] rounded-full',
            defaultOriginPoint === ToothMovementPoints.CrownCenter &&
              'bg-originPointBg border-originPointBorder'
          )}
        />
      </div>
      <div
        onClick={() =>
          setSelectedToothOriginPoint(ToothMovementPoints.CrownTip)
        }
        className={cn(
          '-translate-y-[50%] -translate-x-[50%] absolute left-5 top-[89px] p-3 w-1.5 h-1.5 hover:cursor-pointer transition-all',
          selectedToothOriginPoint === ToothMovementPoints.CrownTip &&
            '[&>div]:w-3 [&>div]:h-3 [&>div]:bg-[#70CADE] [&>div]:border-[#344952]',
          !(selectedToothOriginPoint === ToothMovementPoints.CrownTip) &&
            '[&>div]:betterhover:hover:border-2 [&>div]:betterhover:hover:bg-[#70CADE] [&>div]:betterhover:hover:border-[#344952] [&>div]:betterhover:hover:w-2 [&>div]:betterhover:hover:h-2'
        )}
      >
        <div
          className={cn(
            'absolute top-1/2 left-1/2 w-1.5 h-1.5 -translate-y-[50%] -translate-x-[50%] bg-[#455A64] border border-[#6899B0] rounded-full',
            defaultOriginPoint === ToothMovementPoints.CrownTip &&
              'bg-originPointBg border-originPointBorder'
          )}
        />
      </div>
      <PivotSVG />
    </div>
  );
}
